export enum TypeMaterialEnum {
  INIES_MATERIAL = "INIES_MATERIAL",
  FICHE_CONFIGURE = "FICHE_CONFIGURE",
  UNKNOWN = "UNKNOWN",
}
